import peerNoms from 'cccisd-laravel-peer-noms';

export default {
    components: [peerNoms],
};
